import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {
      uid: 0,
      gold: 0,
    },
    fruitTimeInfo: {
      canBet: false,
      date: "2022-08-18",
      round: 0,
      tsNow: 0,
      tsZero: 0
    },
    round: 0,
    rewardCoins: 0,
    result: { haveRes: false },
    history: [],
    users: [],
    notNetwork: false,
    userHistory: [],
    weekTop1Avatarurl: "",
    currentRanking: {},
    rankList: [],
    slowNetwork: false,//网络比较慢
    newFruit: false,
    top1Uid: 0,
    getTime:true,
  }

  @action async SetSlowNetwork(d) {
    this.data.slowNetwork = d
  }

  @action async roundAdd() {
    if (this.data.round >= 1920) {
      this.data.round = 1
    } else {
      this.data.round = this.data.round + 1
    }
  }
  @action async SetNewFruit(d) {
    this.data.newFruit = d
  }

  @action async GetUserInfoWeb() {
    this.data.notNetwork = false
    let d = await http.post('/web/MyAccountInfo', {})
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
    } else {
      this.data.notNetwork = true
    }
  }

  @action async GetFruitTimeInfo() {
    let d = await http.post('/web/games/fruit/time', {})
    if (d && d.code == 0 && d.res) {
      if (this.data.fruitTimeInfo.tsNow > d.res.tsNow) {
        d.res.tsNow = this.data.fruitTimeInfo.tsNow
      }
      this.data.fruitTimeInfo = d.res
      return this.data.fruitTimeInfo
    }
    return this.data.fruitTimeInfo
  }

  @action async GetFruitTimeInfo2() {
    if (this.data.getTime==false) {
      return
    }
    this.data.getTime = false
    let d = await this.GetFruitTimeInfo()
    this.data.getTime = true
    return d
  }

  @action async BetFruit(req) {
    // 矫正时间
    let d = await http.post('/web/games/fruit/bet', { fruits: req })
    if (d && d.code == 0 && d.res) {
      this.data.notNetwork = false
      return true
    }
    return false
  }

  @action async GetResult(updateRound, userBetCoins) {
    this.data.newFruit = false
    this.data.slowNetwork = true
    this.data.notNetwork = false
    this.data.result = { haveRes: false }
    let d = await http.post('/web/games/fruit/result', {})
    if (d && d.res && d.code == 0) {
      let userBetCoinsBack = d.res.fruit0Coins + d.res.fruit1Coins + d.res.fruit2Coins + d.res.fruit3Coins + d.res.fruit4Coins + d.res.fruit5Coins + d.res.fruit6Coins + d.res.fruit7Coins
      if (updateRound == true && userBetCoins > 0 && userBetCoinsBack == 0) {
        this.data.notNetwork = true
        this.data.newFruit = false
      } else if (d.res.history.length > 0 && d.res.history[0] == -1) {
        this.data.slowNetwork = true
        this.data.newFruit = false
        d.res.haveRes = true
        this.data.result = d.res
        this.data.history = d.res.history
        let userInfo = this.data.userInfo
        userInfo.gold = d.res.coins
        this.data.round = d.res.roundId
        this.data.userInfo = userInfo
        this.data.users = d.res.users
        this.data.rewardCoins = d.res.rewardCoins
        this.data.notNetwork = true
      } else {
        this.data.slowNetwork = false
        this.data.newFruit = true
        d.res.haveRes = true
        this.data.result = d.res
        this.data.history = d.res.history
        let userInfo = this.data.userInfo
        userInfo.gold = d.res.coins
        this.data.round = d.res.roundId
        this.data.userInfo = userInfo
        this.data.users = d.res.users
        this.data.rewardCoins = d.res.rewardCoins
        this.data.notNetwork = false
      }
    } else {
      this.data.notNetwork = true
      this.data.newFruit = false
    }
    console.log("押注结果", d)
  }


  @action async GetUserHistory() {
    // if(this.data.userHistory && this.data.userHistory.length >0){
    //   return this.data.userHistory
    // }
    let d = await http.post('/web/games/fruit/user/history', {})
    if (d && d.code == 0 && d.res) {
      this.data.userHistory = d.res
      return d.res
    }
    return this.data.userHistory
  }

  // @action async GetWeekTop1(daysago) {
  //   let d = await http.post('/web/fruit/week/rank', {daysago:daysago})
  //   if (d && d.code == 0 && d.res) {
  //     if (d.res.list.length > 0) {
  //       this.data.weekTop1Avatarurl = d.res.list[0].avatarurl
  //     }
  //   }
  //   return this.data.weekTop1Avatarurl
  // }


  @action async GetRank(daysago) {
    // if (this.data.rankList && this.data.rankList.length >0 && this.data.currentRanking){
    //   return
    // } 
    let d = await http.post('/web/fruit/bet/day/rank', {})
    if (d && d.code == 0 && d.res) {
      this.data.rankList = d.res.list
      this.data.currentRanking = d.res.myrank
      if (d.res.list.length > 0) {
        this.data.weekTop1Avatarurl = d.res.list[0].avatarurl
        this.data.top1Uid = d.res.list[0].uid
      }
    }
    return this.data.rankList
  }

  @action async getGameUserList() {
    let res = await http.post("/web/games/fruit/carousel", {})
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }

  @action async getFruitGameBetRecordCurrent() {
    let res = await http.post("/web/games/fruit/bet/record/current", {})
    if (res && res.res) {
      return res.res
    } else {
      return {}
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/fruit.js